module.exports = __webpack_public_path__ + "static/media/building 01.d39ac2e4.png";